import React from 'react'
import VerifiedIcon from '../VerifiedIcon'
import LinkedAuthor from './LinkedAuthor'
import AuthorNameAndHandle from './AuthorNameAndHandle'

type AuthorColumnProps = {
  name?: string
  handle?: string
  url?: string
  verified?: boolean
}

const AuthorColumn = ({ name, handle, url, verified }: AuthorColumnProps) => {
  if (name && handle) {
    return <AuthorNameAndHandle name={name} handle={handle} url={url} verified={verified} />
  }

  return (
    <>
      {!handle ? <LinkedAuthor url={url} name={name} /> : <LinkedAuthor url={url} name={handle} />}
      {verified ? <VerifiedIcon /> : undefined}
    </>
  )
}

export default AuthorColumn
